import { ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'

type CustomerDataSectionProps = {
  section: any,
  index: any
}

const Component = ({ section, index }: CustomerDataSectionProps): ReactElement => {
  const navigate = useNavigate()

  const handleEditButtonClick = (section: string) => {
    if (
      section === 'Ihre Rechnung & Lieferung' ||
      section === 'Ihre persönlichen Daten'
    ) {
      navigate('/kundendaten')
    }
    if (
      section === 'Ihre Daten zur PV-Anlage'
    ) {
      navigate('/erzeugungsanlage')
    }
    if (
      section === 'SENEC.Family & Friends' ||
      section === 'SENEC.Cloud to Go' ||
      section === 'SENEC.Family & Friends 2' ||
      section === 'SENEC.Wärme'
    ) {
      navigate('/stromlieferant')
    }
  }

  const showEditButton = (
    section.section === 'Ihre Rechnung & Lieferung' ||
    section.section === 'Ihre Daten zur PV-Anlage' ||
    section.section === 'Ihre persönlichen Daten' ||
    section.section === 'SENEC.Cloud to Go' ||
    section.section === 'SENEC.Family & Friends 2' ||
    section.section === 'SENEC.Family & Friends' ||
    section.section === 'SENEC.Wärme' ||
    section.section === 'Ihre persönlichen Daten'
  )

  return (
    <div key={index} className={`section md:m-4 md:p-10 xl:p-16 ${index % 2 === 0 ? 'bg-gray-lighter' : 'bg-gray-light'}`}>
      <div className="section-header flex justify-between items-center">
        <h3 className="headline h3">{section.section}</h3>
        {showEditButton &&
          <button className="edit-button" onClick={() => handleEditButtonClick(section.section)}>bearbeiten</button>
        }
      </div>
      <div className="subitems grid md:grid-cols-2 gap-4">
        {Object.entries(section.headlines).map(([headline, details]: [string, any], headlineIndex) => (
          <div key={headlineIndex}>
            <h5 className="h5 font-bold px-3 pt-2">{headline}</h5>
            {details.map((detail: string, idx: number) =>
              <p key={idx} className={`px-5 mb-0 ${idx > 0 ? 'pt-1' : 'py-0'}`}>{detail}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default Component
